import * as React from 'react';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import styles from './Copyright.module.css';

function Copyright(props) {
    return (
      <footer className={styles.footer}>
      <Typography variant="body2" color="text.secondary" align="center" {...props}>
        {'Copyright © '}
        <Link color="inherit" href="https://VentureEvaluations.com/">
          Venture Evaluations
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}
      </Typography>
      </footer>
    );
  }
export default Copyright;